import axios from 'axios';
import { createInstance, baseRbURL, basePyURL, commonRbConfig, commonPyConfig, commonPyTransformResponse, handleBeforeRequest, handlePyResponseSuccess, handleResponseError } from '@cordata/buffet';

const baseInstance = axios.create({
  ...commonRbConfig,
  baseRbURL,
});

const authorizedInstance = createInstance({
  api: 'r',
  isAuthed: true,
  baseURL: baseRbURL,
});

const fullAuthorizedInstance = createInstance({
  api: 'p',
  isAuthed: true,
});

const basePyInstance = axios.create({
  baseURL: basePyURL,
  transformResponse: commonPyTransformResponse,
});

const extInstance = axios.create({
  baseURL: `${basePyURL}/api`,
  transformResponse: commonPyTransformResponse,
  withCredentials: true,
});

const citInstance = axios.create({
  baseURL: `${basePyURL}/api/cit`,
  transformResponse: commonPyTransformResponse,
  withCredentials: true,
});

const authorizedPyInstance = axios.create({
  ...commonPyConfig,
  baseURL: basePyURL,
});
authorizedPyInstance.interceptors.request.use(handleBeforeRequest);
authorizedPyInstance.interceptors.response.use(handlePyResponseSuccess, handleResponseError);

const authorizedPySessionInstance = axios.create({
  ...commonPyConfig,
  baseURL: basePyURL,
});
authorizedPySessionInstance.interceptors.request.use(handleBeforeRequest);
authorizedPySessionInstance.interceptors.response.use(handlePyResponseSuccess, handleResponseError);

const authorizedPyPublicInstance = axios.create({
  ...commonPyConfig,
  baseURL: `${basePyURL}/api/data/public`,
});
authorizedPyPublicInstance.interceptors.request.use(handleBeforeRequest);
authorizedPyPublicInstance.interceptors.response.use(handlePyResponseSuccess, handleResponseError);

const authorizedInstanceNoBase = axios.create({
  ...commonPyConfig,
});
authorizedInstanceNoBase.interceptors.request.use(handleBeforeRequest);
authorizedInstanceNoBase.interceptors.response.use(handlePyResponseSuccess, handleResponseError);

export {
  baseInstance,
  authorizedInstance,
  basePyInstance,
  authorizedPyInstance,
  authorizedPySessionInstance,
  authorizedInstanceNoBase,
  authorizedPyPublicInstance,
  extInstance,
  citInstance,
  fullAuthorizedInstance,
};
